import { CircularProgress, Container } from '@mui/material';
import SimpleAlert from '../../../../../components/display/SimpleAlert';
import useGetFeedbacks from '../hooks/useGetFeedbacks';
import FeedbackComponentWrapper from './FeedbackComponentWrapper';
import { USER_FEEDBACKS_LIST } from '../../../../../enums/ApiPaths';

export default function UserFeedbacks() {
    const fetch = useGetFeedbacks(USER_FEEDBACKS_LIST);

   if (fetch.isLoading) {
    return (
        <Container>
            <CircularProgress/>
        </Container>
    )
  } else if (!fetch.isLoading && fetch.error) {
    return (
        <Container>
            <SimpleAlert severity={"error"} message={"SomethingWentWrong"}/>
        </Container>
    )
  } 

  return <FeedbackComponentWrapper apiKey={USER_FEEDBACKS_LIST} type="user" fetch={fetch} title={"UserFeedback"} noDataMessage={"NoUserFeedbacks"}/>;
}


